// File: frontend/src/utils/pdfExport.js

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

/**
 * Export data array to a styled A4 PDF document
 * @param {string} title - Report title
 * @param {Array<string>} headers - Table column header titles
 * @param {Array<Array>} data - Table row data matrix
 * @param {string} schoolName - School branding name
 */
export const exportToPDF = (title = 'Report', headers = [], data = [], schoolName = 'School Management System') => {
  try {
    const doc = new jsPDF('p', 'mm', 'a4');
    const today = new Date().toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });

    // Top Header Banner
    doc.setFillColor(37, 99, 235); // Primary brand color
    doc.rect(0, 0, 210, 22, 'F');

    // Header School Name
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14);
    doc.setTextColor(255, 255, 255);
    doc.text(schoolName.toUpperCase(), 14, 14);

    // Report Title & Date Subheader
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14);
    doc.setTextColor(30, 41, 59);
    doc.text(title, 14, 32);

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(100, 116, 139);
    doc.text(`Generated Date: ${today}`, 14, 38);

    // Generate Styled Data Table
    autoTable(doc, {
      startY: 44,
      head: [headers],
      body: data,
      theme: 'grid',
      headStyles: {
        fillColor: [30, 41, 59], // Slate-800
        textColor: [255, 255, 255],
        fontStyle: 'bold',
        fontSize: 9
      },
      bodyStyles: {
        fontSize: 8.5,
        textColor: [51, 65, 85]
      },
      alternateRowStyles: {
        fillColor: [248, 250, 252] // Slate-50
      },
      margin: { left: 14, right: 14 }
    });

    // Page Footer
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(148, 163, 184);
      doc.text(
        `Page ${i} of ${pageCount} • Official Confidential Report`,
        14,
        doc.internal.pageSize.height - 10
      );
    }

    // Save Downloadable File
    const filename = `${title.replace(/[^a-zA-Z0-9]/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`;
    doc.save(filename);
  } catch (error) {
    console.error('Error generating PDF:', error);
    alert('Failed to generate PDF document');
  }
};
